import classnames from 'classnames';

export function getCompareIconClassName(value, compareValue) {
  return classnames({
    'icon-arrow-down8 text-green-50': value < compareValue,
    'icon-arrow-up8 text-orange-40': value > compareValue,
  });
}
